import Drawing from 'dxf-writer';

// 日本語文字をDXFで確実に表示できる形式に変換する関数
const escapeJapaneseText = (text) => {
  if (!text) return '';
  
  // 主要な日本語文字を英語に変換（DXFの制限を回避）
  const japaneseMap = {
    'リビング': 'Living',
    '寝室': 'Bedroom',
    'キッチン': 'Kitchen',
    '浴室': 'Bathroom',
    '洗面所': 'Bathroom',
    'トイレ': 'Toilet',
    '玄関': 'Entrance',
    '廊下': 'Corridor',
    '階段': 'Stairs',
    '収納': 'Storage',
    '和室': 'Japanese Room',
    '洋室': 'Western Room',
    '子供部屋': 'Children Room',
    '主寝室': 'Master Bedroom',
    '書斎': 'Study',
    'LDK': 'LDK',
    'WIC': 'WIC',
    'ポーチ': 'Porch',
    'ホール': 'Hall',
    '1F': '1F',
    '2F': '2F',
    '3F': '3F'
  };
  
  // マッピングがあれば変換
  if (japaneseMap[text]) {
    return japaneseMap[text];
  }
  
  // マッピングがない場合は、日本語文字のみを英語に変換し、その他の文字は保持
  let result = text;
  
  // 一般的なひらがな・カタカナの変換
  const charMap = {
    'あ': 'a', 'い': 'i', 'う': 'u', 'え': 'e', 'お': 'o',
    'か': 'ka', 'き': 'ki', 'く': 'ku', 'け': 'ke', 'こ': 'ko',
    'さ': 'sa', 'し': 'shi', 'す': 'su', 'せ': 'se', 'そ': 'so',
    'た': 'ta', 'ち': 'chi', 'つ': 'tsu', 'て': 'te', 'と': 'to',
    'な': 'na', 'に': 'ni', 'ぬ': 'nu', 'ね': 'ne', 'の': 'no',
    'は': 'ha', 'ひ': 'hi', 'ふ': 'fu', 'へ': 'he', 'ほ': 'ho',
    'ま': 'ma', 'み': 'mi', 'む': 'mu', 'め': 'me', 'も': 'mo',
    'や': 'ya', 'ゆ': 'yu', 'よ': 'yo',
    'ら': 'ra', 'り': 'ri', 'る': 'ru', 'れ': 're', 'ろ': 'ro',
    'わ': 'wa', 'を': 'wo', 'ん': 'n',
    'が': 'ga', 'ぎ': 'gi', 'ぐ': 'gu', 'げ': 'ge', 'ご': 'go',
    'ざ': 'za', 'じ': 'ji', 'ず': 'zu', 'ぜ': 'ze', 'ぞ': 'zo',
    'だ': 'da', 'ぢ': 'ji', 'づ': 'zu', 'で': 'de', 'ど': 'do',
    'ば': 'ba', 'び': 'bi', 'ぶ': 'bu', 'べ': 'be', 'ぼ': 'bo',
    'ぱ': 'pa', 'ぴ': 'pi', 'ぷ': 'pu', 'ぺ': 'pe', 'ぽ': 'po',
    'ア': 'A', 'イ': 'I', 'ウ': 'U', 'エ': 'E', 'オ': 'O',
    'カ': 'KA', 'キ': 'KI', 'ク': 'KU', 'ケ': 'KE', 'コ': 'KO',
    'サ': 'SA', 'シ': 'SHI', 'ス': 'SU', 'セ': 'SE', 'ソ': 'SO',
    'タ': 'TA', 'チ': 'CHI', 'ツ': 'TSU', 'テ': 'TE', 'ト': 'TO',
    'ナ': 'NA', 'ニ': 'NI', 'ヌ': 'NU', 'ネ': 'NE', 'ノ': 'NO',
    'ハ': 'HA', 'ヒ': 'HI', 'フ': 'FU', 'ヘ': 'HE', 'ホ': 'HO',
    'マ': 'MA', 'ミ': 'MI', 'ム': 'MU', 'メ': 'ME', 'モ': 'MO',
    'ヤ': 'YA', 'ユ': 'YU', 'ヨ': 'YO',
    'ラ': 'RA', 'リ': 'RI', 'ル': 'RU', 'レ': 'RE', 'ロ': 'RO',
    'ワ': 'WA', 'ヲ': 'WO', 'ン': 'N',
    'ガ': 'GA', 'ギ': 'GI', 'グ': 'GU', 'ゲ': 'GE', 'ゴ': 'GO',
    'ザ': 'ZA', 'ジ': 'JI', 'ズ': 'ZU', 'ゼ': 'ZE', 'ゾ': 'ZO',
    'ダ': 'DA', 'ヂ': 'JI', 'ヅ': 'ZU', 'デ': 'DE', 'ド': 'DO',
    'バ': 'BA', 'ビ': 'BI', 'ブ': 'BU', 'ベ': 'BE', 'ボ': 'BO',
    'パ': 'PA', 'ピ': 'PI', 'プ': 'PU', 'ペ': 'PE', 'ポ': 'PO'
  };
  
  // 一般的な漢字の変換
  const kanjiMap = {
    '部': 'Room', '屋': 'Room', '室': 'Room', '間': 'Room',
    '居': 'Living', '住': 'Living', '生': 'Living',
    '寝': 'Bed', '眠': 'Sleep', '休': 'Rest',
    '食': 'Dining', '飯': 'Meal', '料': 'Kitchen',
    '浴': 'Bath', '洗': 'Wash', '面': 'Face',
    '便': 'Toilet', '手': 'Hand', '洗': 'Wash',
    '玄': 'Entrance', '関': 'Gate', '門': 'Door',
    '廊': 'Corridor', '下': 'Lower', '上': 'Upper',
    '階': 'Floor', '段': 'Step', '梯': 'Stairs',
    '収': 'Storage', '納': 'Store', '蔵': 'Storage',
    '和': 'Japanese', '洋': 'Western', '子': 'Child',
    '供': 'Children', '主': 'Master', '書': 'Study',
    '斎': 'Study', '客': 'Guest', '応': 'Reception',
    '接': 'Reception', '待': 'Waiting', '合': 'Meeting',
    '家': 'Home', '宅': 'House', '建': 'Building',
    '築': 'Construction', '設': 'Equipment', '備': 'Equipment',
    '機': 'Machine', '器': 'Device', '具': 'Tool',
    '品': 'Item', '物': 'Thing', '品': 'Product',
    '新': 'New', '古': 'Old', '大': 'Large',
    '小': 'Small', '中': 'Medium', '高': 'High',
    '低': 'Low', '長': 'Long', '短': 'Short',
    '広': 'Wide', '狭': 'Narrow', '深': 'Deep',
    '浅': 'Shallow', '厚': 'Thick', '薄': 'Thin',
    '重': 'Heavy', '軽': 'Light', '硬': 'Hard',
    '柔': 'Soft', '強': 'Strong', '弱': 'Weak',
    '美': 'Beautiful', '醜': 'Ugly', '好': 'Good',
    '悪': 'Bad', '良': 'Good', '悪': 'Bad',
    '安': 'Safe', '危': 'Dangerous', '静': 'Quiet',
    '騒': 'Noisy', '明': 'Bright', '暗': 'Dark',
    '暖': 'Warm', '寒': 'Cold', '暑': 'Hot',
    '涼': 'Cool', '乾': 'Dry', '湿': 'Wet',
    '清': 'Clean', '汚': 'Dirty', '整': 'Organized',
    '乱': 'Messy', '新': 'New', '旧': 'Old',
    '現': 'Current', '古': 'Old', '今': 'Now',
    '昔': 'Past', '未': 'Future', '来': 'Coming',
    '去': 'Going', '入': 'Enter', '出': 'Exit',
    '開': 'Open', '閉': 'Close', '始': 'Start',
    '終': 'End', '始': 'Begin', '終': 'Finish',
    '上': 'Up', '下': 'Down', '左': 'Left',
    '右': 'Right', '前': 'Front', '後': 'Back',
    '内': 'Inside', '外': 'Outside', '中': 'Middle',
    '間': 'Between', '近': 'Near', '遠': 'Far',
    '東': 'East', '西': 'West', '南': 'South',
    '北': 'North', '中央': 'Center', '中心': 'Center'
  };
  
  // 漢字を変換
  for (const [kanji, english] of Object.entries(kanjiMap)) {
    result = result.replace(new RegExp(kanji, 'g'), english);
  }
  
  // ひらがな・カタカナを変換
  for (const [japanese, english] of Object.entries(charMap)) {
    result = result.replace(new RegExp(japanese, 'g'), english);
  }
  
  // 変換後も日本語文字が残っている場合は、それらを除去
  result = result.replace(/[^\x00-\x7F]/g, '');
  
  // 空文字列になった場合は元のテキストをそのまま使用（ASCII文字のみ）
  if (!result.trim()) {
    return text.replace(/[^\x00-\x7F]/g, '') || 'Room';
  }
  
  return result;
};

// Konva単位からmmへの変換係数（Room.jsxと同じ）
const KONVA_UNIT_TO_MM = 910 / 50; // 50 Konva単位 = 910mm

// 寸法線を描画する関数（簡略版）
const drawDimension = (d, x1, y1, x2, y2, konvaValue) => {
  d.setActiveLayer('DIMENSIONS');
  
  // Konva単位をmmに変換
  const mmValue = Math.round(konvaValue * KONVA_UNIT_TO_MM);
  
  // 寸法線のオフセット距離
  const offset = 50;
  
  // 水平線の場合
  if (Math.abs(y2 - y1) < 10) {
    const dimY = y1 - offset;
    d.drawLine(x1, dimY, x2, dimY);
    // 寸法値を表示
    const textX = (x1 + x2) / 2;
    const textY = dimY - 10;
    d.setActiveLayer('TEXT');
    d.drawText(textX, textY, 6, 0, `${mmValue}mm`);
  }
  // 垂直線の場合
  else if (Math.abs(x2 - x1) < 10) {
    const dimX = x2 + offset;
    d.drawLine(dimX, y1, dimX, y2);
    // 寸法値を表示
    const textX = dimX + 10;
    const textY = (y1 + y2) / 2;
    d.setActiveLayer('TEXT');
    d.drawText(textX, textY, 6, 0, `${mmValue}mm`);
  }
  // 斜線の場合
  else {
    const angle = Math.atan2(y2 - y1, x2 - x1);
    const offsetX1 = x1 + offset * Math.cos(angle + Math.PI/2);
    const offsetY1 = y1 + offset * Math.sin(angle + Math.PI/2);
    const offsetX2 = x2 + offset * Math.cos(angle + Math.PI/2);
    const offsetY2 = y2 + offset * Math.sin(angle + Math.PI/2);
    
    d.drawLine(offsetX1, offsetY1, offsetX2, offsetY2);
    // 寸法値を表示
    const textX = (offsetX1 + offsetX2) / 2;
    const textY = (offsetY1 + offsetY2) / 2;
    d.setActiveLayer('TEXT');
    d.drawText(textX, textY, 6, 0, `${mmValue}mm`);
  }
};

// 間取りデータをDXF形式でエクスポートする関数
export const exportToDXF = (floorRooms, floorNames) => {
  const d = new Drawing();
  
  // 単位を設定（ミリメートル）
  d.setUnits('Millimeters');
  
  // レイヤーを設定
  d.addLayer('WALLS', Drawing.ACI.RED, 'CONTINUOUS');
  d.addLayer('ROOMS', Drawing.ACI.BLUE, 'CONTINUOUS');
  d.addLayer('TEXT', Drawing.ACI.GREEN, 'CONTINUOUS');
  d.addLayer('DIMENSIONS', Drawing.ACI.CYAN, 'CONTINUOUS');
  
  // 各フロアを処理
  Object.keys(floorRooms).forEach((floorKey, floorIndex) => {
    const rooms = floorRooms[floorKey];
    const floorName = floorNames[floorKey] || floorKey;
    
    // フロア名を追加
    const floorTitleY = -floorIndex * 1000; // フロア間の間隔
    d.setActiveLayer('TEXT');
    d.drawText(0, floorTitleY - 50, 10, 0, escapeJapaneseText(floorName));
    
    // 各部屋を処理
    rooms.forEach((room) => {
      const roomY = floorTitleY - room.y;
      
      if (room.type === 'wall') {
        // 壁の場合
        d.setActiveLayer('WALLS');
        d.drawLine(room.x, roomY, room.x2, roomY - (room.y2 - room.y));
        
        // 壁の長さを寸法線で表示
        const wallLength = Math.sqrt(Math.pow(room.x2 - room.x, 2) + Math.pow(room.y2 - room.y, 2));
        drawDimension(d, room.x, roomY, room.x2, roomY - (room.y2 - room.y), wallLength);
      } else {
        // 部屋の場合
        const x1 = room.x;
        const y1 = roomY;
        const x2 = room.x + room.width;
        const y2 = roomY - room.height;
        
        // 部屋の外枠を描画
        d.setActiveLayer('ROOMS');
        d.drawLine(x1, y1, x2, y1); // 上辺
        d.drawLine(x2, y1, x2, y2); // 右辺
        d.drawLine(x2, y2, x1, y2); // 下辺
        d.drawLine(x1, y2, x1, y1); // 左辺
        
        // 部屋名を追加
        const textX = (x1 + x2) / 2;
        const textY = (y1 + y2) / 2;
        d.setActiveLayer('TEXT');
        d.drawText(textX, textY, 8, 0, escapeJapaneseText(room.name));
        
        // 寸法を追加
        drawDimension(d, x1, y1, x2, y1, room.width); // 幅の寸法
        drawDimension(d, x2, y1, x2, y2, room.height); // 高さの寸法
      }
    });
  });
  
  return d.toDxfString();
};

// DXFファイルをダウンロードする関数
export const downloadDXF = (dxfContent, filename = 'floorplan.dxf') => {
  const blob = new Blob([dxfContent], { type: 'application/dxf' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}; 